import { css } from "styled-components"
import {
    padding,
    color,
    space,
    height,
    fontWeight,
} from '../../util/styles'

import { themeColor, themeFontSize, themeFontWeight, themeFontFamily } from '../../util/themeLenses'
import { GRAY_COLOR } from './SimpleInput'


const getMaskInputLabelColor = (focused, error, theme) => {
    if (error){
        return 'error'
    }
    if (focused) {
        return theme.components.simpleInput.focusColor
    }
    return GRAY_COLOR
}

const placeholderColor = ({ focused, valid }) => {
    if (valid == false){
        return focused == 'true' ? themeColor('error_light') :  themeColor('error')
    } else if (focused == 'true'){
        return themeColor('gray40')
    }
    return themeColor('gray60')
}

export const InputBorderStyles = css`
    border-style: solid;
    border-color: ${({ focused, error, theme }) => themeColor(getMaskInputLabelColor(focused, error, theme))};
    border-radius: ${({ borderRadius, theme }) => borderRadius || theme.components.simpleInput.borderRadius};
    border-width: ${({ borderWidth, theme }) => borderWidth || theme.components.simpleInput.borderWidth};
`

const InputStyles = css`
    ${padding}
    ${color}
    ${space}
    ${height}
    padding-top: ${({ theme }) => theme.components.simpleInput.paddingTop };
    width: calc(100% - 2*${({ padding }) => padding});
    outline: unset;
    border: 0;
    font-size: ${({ fontSize, theme }) => themeFontSize(fontSize || (theme && theme.components.input.fontSize))};
    font-weight: ${({ fontWeight, theme }) => themeFontWeight(fontWeight || (theme && theme.components.input.fontWeight))};
    ${themeFontFamily()}
    ::placeholder {
        ${themeFontFamily()}
        ${fontWeight};
        color: ${placeholderColor}
    }
    :-webkit-autofill {
        background: ${themeColor('white')} !important;
        box-shadow: inset 0 0 0px 9999px ${themeColor('white')};
        -webkit-box-shadow: inset 0 0 0px 9999px ${themeColor('white')};
    }
`

export default InputStyles